<template>
  <InfoLayout
    v-if="!isMobile"
    :current-path="reverseFull({ name: 'pressa' })"
    :is-policy="false"
  >
    <template #title>
      {{ t('О нас говорят', options) }}
    </template>
    <template #content>
      <div class="d-flex flex-column ga-6">
        <PressaBanner />
        <VideoReviews
          v-if="context.lpu_video_reviews && context.lpu_video_reviews.length"
          data-qa="video_reviews"
          :lpu-video-reviews="context.lpu_video_reviews"
        />
        <component
          :is="isMobile ? DoctorReviewsMobile : DoctorReviewsDesktop"
          v-if="context.doctor_reviews && context.doctor_reviews.length"
          data-qa="doctor_reviews"
          :class="{ 'mx-2': isMobile }"
          :doctor-reviews="context.doctor_reviews"
        />
        <component
          :is="isMobile ? MassMediaMobile : MassMediaDesktop"
          v-if="context.news && context.news.length"
          data-qa="mass_media"
          :class="{ 'mx-2': isMobile }"
          :news="context.news"
        />
      </div>
    </template>
  </InfoLayout>
  <div
    v-else
    class="d-flex flex-column ga-6"
  >
    <PressaBanner />
    <VideoReviews
      v-if="context.lpu_video_reviews && context.lpu_video_reviews.length"
      data-qa="video_reviews"
      :lpu-video-reviews="context.lpu_video_reviews"
    />
    <component
      :is="isMobile ? DoctorReviewsMobile : DoctorReviewsDesktop"
      v-if="context.doctor_reviews && context.doctor_reviews.length"
      data-qa="doctor_reviews"
      :class="{ 'mx-2': isMobile }"
      :doctor-reviews="context.doctor_reviews"
    />
    <component
      :is="isMobile ? MassMediaMobile : MassMediaDesktop"
      v-if="context.news && context.news.length"
      data-qa="mass_media"
      :class="{ 'mx-2': isMobile }"
      :news="context.news"
    />
  </div>
</template>

<script setup lang="ts">
import { useContextStore, useURLStore } from 'src/store'
import I18NextVue from 'i18next'
import VideoReviews from 'src/components/pages/info/pressa/components/VideoReviews.vue'
import DoctorReviewsDesktop from 'src/components/pages/info/pressa/components/desktop/DoctorReviewsDesktop.vue'
import MassMediaDesktop from 'src/components/pages/info/pressa/components/desktop/MassMediaDesktop.vue'
import MassMediaMobile from 'src/components/pages/info/pressa/components/mobile/MassMediaMobile.vue'
import PressaBanner from 'src/components/pages/info/pressa/components/PressaBanner.vue'
import DoctorReviewsMobile from 'src/components/pages/info/pressa/components/mobile/DoctorReviewsMobile.vue'
import InfoLayout from 'src/layouts/info-pages/InfoLayout.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context } = useContextStore()
const isMobile = context.flavour === 'mobile'

const { reverseFull } = useURLStore()
</script>
